<template>
<div>
  <template v-for="category in schedule.categories">
    <div
      :id="`category-row-${category.id}`"
      :key="`category_${category.id}`"
      :class="`category category-${mediaquery} ${getActiveClassname(category.id)}`">
      <el-row
        type="flex"
        justify="space-between"
        class="category-row">
        <!---<div>{{ category.namePM }}</div>--->
        <div>{{ $t(`deck.${category.shipCode}_${category.code}`) }}</div>
        <el-row
          type="flex"
          justify="space-between">
          <div class="category-price">{{ category.price | currencyFormat(category.currency, _self) }}<sup>*</sup></div>
          <div class="category-button">
            <pm-arrow-button
              :isActive="isActive(category.id)"
              @click="setActiveCategory(category.id)" />
          </div>
        </el-row>
      </el-row>
    </div>
    <el-collapse-transition
      :key="`category-data_${category.id}`">
      <pm-category-cabins v-if="category.id === idActiveCategory"
        :idxSchedule="idxSchedule"
        :category="category" />
    </el-collapse-transition>
  </template>
  <slot name="priceinfo"></slot>
</div>
</template>

<script>
import CabinsDesktop from './CabinsDesktop'
import { categoryMixin } from '../utils/categoryMixin'

export default {
  name: 'CategoriesDesktop',
  mixins: [categoryMixin],
  components: {
    pmCategoryCabins: CabinsDesktop
  }
}
</script>

<style lang="scss">
.category-4 {
  width: 80%;
  margin: auto;
}

.category-5 {
  width: 60%;
  margin: auto;
}

.category {
  height: 9rem;
  background: #00355E;
  margin-top: 2rem;

  .category-row {
    line-height: 2.4rem;
    padding-top: 3.6rem;
    padding-left: 3rem;
    color: #fff;
    font-family: "Montserrat";
    font-size: 2.4rem;
    font-weight: normal;
    letter-spacing: 0.24px;

    .category-button {
      margin-top: -2rem;
      margin-left: 4rem;
      margin-right: 3rem;
    }
  }
}

.category.active {
  background-color: #C9E3F7;

  .category-row {
    color: #00355E;
  }
}
</style>
